import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Card from '@material-ui/core/Card'
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos'
import CardContent from '@material-ui/core/CardContent'
import CardMedia from '@material-ui/core/CardMedia'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import styled from 'styled-components'
import ConclusionBar from '../ConclusionBar'
import * as textUtils from '../../utils/text'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import Link from '@material-ui/core/Link';
import { Link as RouterLink } from 'react-router-dom'

const useStyles = makeStyles({
  root: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  first_card: {
    display: 'flex',
    alignItems: 'stretch',
    height: '100%'
  },
  media: {
    height: 188,
    position: 'relative',
    opacity: 1,
    flex: 1
  },
  cardTitle: {
    color: '#fff',
    margin: 10,
    position: 'absolute',
    bottom: 0,
    display: '-webkit-box',
    wordBreak: 'break-word',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    lineClamp: 3,
    '-webkit-box-orient': 'vertical'
  },
  largeCardTitle: {
    fontSize: '24px',
    marginBottom: '24px'
  },
  text: {
    height: '3.6em',
    padding: 0,
    display: '-webkit-box',
    wordBreak: 'break-word',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    lineClamp: 3,
    '-webkit-box-orient': 'vertical'
  },
  largeCardText: {
    height: '12em'
  },
  largeMedia: {
    height: '100%',
    flex: 1
  },
  menuLink: {
    '&:hover': {
      textDecoration: 'none',
      display: 'flex'
    }
  }
})

const CardInfo = styled.div`
  max-width: 100%;
  max-height: 100%;
  flex: 1;
  padding: 24px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
`

const ImageOverlay = styled.div`
  width: 100%;
  height: 100%;
  background: transparent linear-gradient(180deg, #4d4f5c00 0%, #0000008c 100%) 0% 0% no-repeat padding-box;
  opacity: 1;
`

const ActionBox = styled.div`
  width: 100%;
  height: 78px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-end
`

const CardCourse = ({ item, index, isUserCourse }) => {
  const classes = useStyles()
  const isDefaultBreakpoint = useMediaQuery('(min-width:1050px)')

  const isFirstCard = isDefaultBreakpoint && isUserCourse && (index === 0);
  const { ultimo_conteudo, primeiro_conteudo, apresentacao, _id, progresso } = item

  const linkToCourse = () => {
    if ((ultimo_conteudo) && (progresso < 100)) {
      return `/curso/${_id}/${ultimo_conteudo}`
    } else if ((apresentacao) && (progresso < 100)) {
      return `/curso/${_id}/apresentacao`
    } else if (progresso >= 100) {
      return `/curso/${_id}/concluido`
    } else if (primeiro_conteudo !== '' && primeiro_conteudo !== null) {
      return `/curso/${_id}/${primeiro_conteudo}`
    } else {
      return `/curso/${_id}/semconteudo`
    }
  }

  return (
    <Card className={isFirstCard ? classes.first_card : classes.root} elevation={1} >
      <CardMedia className={isFirstCard ? classes.largeMedia : classes.media} image={item.capa}>
        <ImageOverlay>
          {!isFirstCard && <Typography gutterBottom variant="h5" component="h2" className={classes.cardTitle} style={{ fontSize: '20px' }}>
            {item.titulo}
          </Typography>}
        </ImageOverlay>
      </CardMedia>
      <CardInfo>
        <CardContent className={isFirstCard ? `${classes.largeCardText} + ${classes.text}` : classes.text}>
          {isFirstCard && <Typography gutterBottom variant="h5" component="h2" className={classes.largeCardTitle} style={{ fontSize: '20px' }} color="primary">
            {item.titulo}
          </Typography>}
          <Typography variant="body2" color="textSecondary" component="p" style={{ maxHeight: '100%' }}>
            {textUtils.truncateEllipsis(item.descricao, 150)}
          </Typography>
        </CardContent>
        <ActionBox>
          {ultimo_conteudo ? <ConclusionBar progress={(item || {}).progresso || 0} /> : ''}
          <Link component={RouterLink} to={linkToCourse()} className={classes.menuLink}>
            <Button variant="outlined" color="primary" endIcon={<ArrowForwardIosIcon style={{ fontSize: '16px' }} />}>{ultimo_conteudo ? 'Continuar' : 'Iniciar curso'}</Button>
          </Link>
        </ActionBox>
      </CardInfo>
    </Card>
  )
}

export default CardCourse